import React from "react";
import googlePlay from "../../assets/googlePlay.svg";
import appStore from "../../assets/appStore.svg";
import logoFooter from "../../assets/logoFooter.svg";
import "./styles.scss";

const Footer = () => {
  let currentDate = new Date();

  return (
    <footer className="footer-wrapper container d-justify-center">
      <div className="footer-content">
        <div className="footer-wrapper__info d-flex text-left">
          <img src={logoFooter} alt="logo footer" />
          <p className="paragraph-12">
            &copy; {currentDate.getFullYear()} RIMAC Seguros y Reaseguros.
          </p>
          <p className="showOnlyInDesktop paragraph-12">
            Todos los derechos reservados
          </p>
        </div>
        <div className="footer-wrapper__store d-flex">
          <div className="footer-wrapper--devices">
            <p className="title-07">Descarga nuestra App</p>
          </div>
          <div className="footer-wrapper--desktop">
            <a
              className="d-flex align-items-center paragraph-12"
              href="https://itunes.apple.com/pe/app/rimac-app/id602975058?mt=8"
            >
              <img src={appStore} alt="app store logo" /> App Store
            </a>
            <a
              className="d-flex align-items-center paragraph-12"
              href="https://play.google.com/store/apps/details?id=com.rimac.rimac_surrogas&hl=es"
            >
              <img src={googlePlay} alt="google play logo" /> Google Play
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
